$( () => {
    var swiperGallery = new Swiper(".swiper-gallery", {
        slidesPerView: 1,
        spaceBetween: 10,
        freeMode: true,
        centeredSlides: true,
        loop: true,
        navigation: {
            nextEl: ".gallery-next",
            prevEl: ".gallery-prev",
        },
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 15,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 10,
            },
        },
    });

    var swiperBanner = new Swiper(".swiper-banner", {
        slidesPerView: 1,
        pagination: {
            el: ".swiper-pagination",
            // dynamicBullets: true,
            clickable: true,
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        // effect: "creative",
        // creativeEffect: {
        //   prev: {
        //     shadow: true,
        //     translate: ["-120%", 0, -500],
        //   },
        //   next: {
        //     shadow: true,
        //     translate: ["120%", 0, -500],
        //   },
        // },
        // autoplay: {
        //     delay: 2500,
        //     disableOnInteraction: false,
        // },
    });

    var swiperJobs = new Swiper(".swiper-jobs", {
        slidesPerView: 1,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        // pagination: {
        //     el: ".swiper-pagination",
        //     // dynamicBullets: true,
        //     clickable: true,
        // },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 10,
                centerInsufficientSlides: true,
                centeredSlidesBounds: true,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 10,
                centerInsufficientSlides: true,
                centeredSlidesBounds: true,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 10,
                centerInsufficientSlides: true,
                centeredSlidesBounds: true,
            },
        },
    });

    var swiperJobs = new Swiper(".swiper-events", {
        slidesPerView: 1,
        centerInsufficientSlides: true,
        centeredSlidesBounds: true,
        // pagination: {
        //     el: ".swiper-pagination",
        //     // dynamicBullets: true,
        //     clickable: true,
        // },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
        },
        breakpoints: {
            576: {
                slidesPerView: 2,
                spaceBetween: 10,
                centerInsufficientSlides: true,
                centeredSlidesBounds: true,
            },
            992: {
                slidesPerView: 3,
                spaceBetween: 10,
                centerInsufficientSlides: true,
                centeredSlidesBounds: true,
            },
            1200: {
                slidesPerView: 3,
                spaceBetween: 10,
                centerInsufficientSlides: true,
                centeredSlidesBounds: true,
            },
        },
    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/modules/slider.js